import { AtomOptions, ReadOnlySelectorOptions, RecoilState, RecoilValueReadOnly, atom, selector } from 'recoil';

import { PROJECT_RECOIL_KEY } from '@/constants';

const makeUniqueKey = (key: string) => `${PROJECT_RECOIL_KEY}_${key}`;

export const atomWithUniqueKey = <T>(options: AtomOptions<T>): RecoilState<T> => {
  const key = makeUniqueKey(options.key);
  return atom({ ...options, key });
};

export const selectorWithUniqueKey = <T>(options: ReadOnlySelectorOptions<T>): RecoilValueReadOnly<T> => {
  const key = makeUniqueKey(options.key);
  return selector({ ...options, key });
};
